import React from "react";
import SectionTable from "../../components/SuperAdmin/SectionTable";

function AdminDashboard() {
  const dbTables = ["Student", "Faculty", "Courses"];

  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold mb-6 ml-5">Admin Dashboard</h1>
      <SectionTable title="Institute Database Tables" sections={dbTables} />
    </div>
  );
}

export default AdminDashboard;
